import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroRota from '../../actions/rota/adicionarFiltroRota'
import removerFiltroRota from '../../actions/rota/removerFiltroRota'
import listarFiltrosRota from '../../actions/rota/listarFiltrosRota'
import {
  FILTRO_CIDADE_DESTINO,
  FILTRO_CIDADE_ORIGEM,
  FILTRO_DELIMITACAO,
  FILTRO_PREFIXO
} from '../../util/filtros'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscaRota from './FiltroBuscaRota';
import FiltroChaveValor from '../comum/FiltroChaveValor';

export class FiltroRotas extends Component {
  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosRota(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosRota(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro (filtro) {
    this.props.adicionarFiltroRota(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroRota(filtro)
  }

  render () {
    if (!this.props.cidadesOrigem) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaRota
            filtro={FILTRO_DELIMITACAO}
            opcoes={this.props.delimitacoes}
          />
          <FiltroBuscaRota
            filtro={FILTRO_PREFIXO}
            opcoes={this.props.prefixos}
          />
          <FiltroChaveValor
            filtro={FILTRO_CIDADE_ORIGEM}
            opcoes={this.props.cidadesOrigem}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_CIDADE_DESTINO}
            opcoes={this.props.cidadesDestino}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  prefixos: state.filtrosRotas.prefixos,
  delimitacoes: state.filtrosRotas.delimitacoes,
  cidadesOrigem: state.filtrosRotas.cidadesOrigem,
  cidadesDestino: state.filtrosRotas.cidadesDestino,
  filtrosAdicionados: state.filtrosAdicionadosRota,
  empresaSelecionada: state.empresaSelecionada

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroRota,
    removerFiltroRota,
    listarFiltrosRota
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroRotas)
